import { render } from "./Railway.vue?vue&type=template&id=888d512e&scoped=true"
import script from "./Railway.vue?vue&type=script&lang=js"
export * from "./Railway.vue?vue&type=script&lang=js"

import "./Railway.vue?vue&type=style&index=0&id=888d512e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-888d512e"]])

export default __exports__